import PowloFooter from "@/components/powlo/PowloFooter";
import PowloHeader from "@/components/powlo/PowloHeader";

export default function PowloLayout({
  children,
  hideFooter = false,
}: {
  children: React.ReactNode;
  hideFooter?: boolean;
}) {
  return (
    <div className="powlo-site flex min-h-screen flex-col">
      <PowloHeader />
      <main className="flex-1">{children}</main>
      {hideFooter ? null : <PowloFooter />}
    </div>
  );
}
